import { BrandLayout } from "__generated__/gql/graphql";
import {
  BRAND_LAYOUT_HOMEPAGES,
  getLayoutRedirectPath,
} from "components/Layout/brandLayoutUtils";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import { asyncVoid } from "utils/asyncVoidHandler";
import { useCurrentBrandData } from "utils/currentUserHooks";
import { BRAND_BILLING } from "utils/links";

function getHomePageRedirectPath(
  brand: ReturnType<typeof useCurrentBrandData>,
): string | null | undefined {
  if (!brand) return;
  if (brand.isSubscriptionValid === false) return BRAND_BILLING;
  return getLayoutRedirectPath(brand.layout);
}
export default function useHomePageRedirect() {
  const [isRedirecting, setIsRedirecting] = useState<boolean>();
  const router = useRouter();
  const brand = useCurrentBrandData();

  useEffect(() => {
    asyncVoid(router.prefetch(BRAND_BILLING));
  }, [router]);

  useEffect(() => {
    const redirectPath = getHomePageRedirectPath(brand);

    const brandHomePage =
      BRAND_LAYOUT_HOMEPAGES[brand?.layout || BrandLayout.DEFAULT];

    if (
      (router.pathname === "/" || router.pathname === brandHomePage) &&
      redirectPath
    ) {
      setIsRedirecting(true);
      asyncVoid(router.replace(redirectPath));
    } else if (redirectPath === null) {
      setIsRedirecting(false);
    }
  }, [router, brand]);

  return isRedirecting;
}
